import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { MyErrorStateMatcher } from '../verify/feedback.component';
import { Globals } from '../_helpers';
import { AlertService, AuthenticationService } from '../_services';


@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
    usernameFormControl = new FormControl('', [Validators.required,]);


    matcher = new MyErrorStateMatcher();
    userName: FormGroup
    submitted: boolean;
    isErrorUsername: boolean;
    loading: boolean;
    errorMsg: any;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient
    ) { }

    ngOnInit() {
    }

    onSubmit() {
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.usernameFormControl.value == '') {
            this.isErrorUsername = false;
            return false;
        }
        else {
            this.loading = true;
            this.spinner.show();
            // let object={

            //   "id_student"  : this.userName.value.usernameFormControl
            //  }
            // console.log('object',object)
            this.authenticationService.forgetPassword(this.globals.root_url, this.usernameFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.isErrorUsername = false;
                            var id = data.id_self_student;
                            this.loading = false;
                            this.spinner.hide();

                            sessionStorage.setItem('pkshn_username_ps', this.usernameFormControl.value);
                            this.router.navigateByUrl('/verifyotp/' + id);
                        }
                        else {
                            this.isErrorUsername = true;
                            this.errorMsg = data.status;
                            this.loading = false;
                            this.spinner.hide(); 
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorUsername = true;
                        this.errorMsg = 'Invalid Usename !!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }
    onHome() {
        this.router.navigate(['/userlogin'])
    }

}
